import { handleRest } from '../../h2Api'
import * as reviewActions from '../../actions/review/reviewActions'

const initialState = {
  data: handleRest(null),
  allForFile: handleRest(null)
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case reviewActions.REQUEST_FILE_REVIEW:
      return {
        ...state,
        data: handleRest(action)
      }
    case reviewActions.LOAD_REVIEWS_FOR_FILE:
      return {
        ...state,
        allForFile: handleRest(action)
      }
    default:
      return state
  }
}

export default reducers
